import { render, staticRenderFns } from "./CustomEvent.vue?vue&type=template&id=30b7108e&scoped=true&"
import script from "./CustomEvent.vue?vue&type=script&lang=js&"
export * from "./CustomEvent.vue?vue&type=script&lang=js&"
import style0 from "./CustomEvent.vue?vue&type=style&index=0&id=30b7108e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b7108e",
  null
  
)

export default component.exports